import Home from "./components/Home";

function App() {
  return (
    <>
      <div className="max-w-screen-2xl mx-auto">
      <Home />
      </div>
    </>
  );
}

export default App;
